import template from './charge-code-mapping.html';
import controller from './charge-code-mapping.controller';

let chargeCodeMappingComponent = {
  restrict: 'E',
  template,
  controller
};

export default chargeCodeMappingComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/charge-code-mapping/charge-code-mapping.component.js